/*****
 * Created with WebStorm.
 * Date : 2019/5/31.
 * Author : Ztr.
 * Func : 暴露所有的请求
 ******/
import * as common from './modules/common'
import * as user from './modules/user'

import * as IM from './modules/IM'

import * as pe from './modules/patientEnd'
import * as doctor from './modules/doctor'


export default Object.assign(common, user, IM , pe, doctor)




// WEBPACK FOOTER //
// ./src/services/index.js